import styled from '@emotion/styled';
import { css } from '@emotion/core';
import colors from '../../../styling/colors';
import TextButton from '../Buttons/TextButton';

const alertStyles = css`
  width: 100%;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 0 1rem;
  line-height: 1.125rem;
  padding: 0.75rem;
`;

export const ErrorMessage = styled.div`
  background-color: ${colors('errorBackground')};
  color: ${colors('error')};
  ${alertStyles};
`;

export const SuccessMessage = styled.div`
  background-color: ${colors('successBackground')};
  color: ${colors('success')};
  ${alertStyles};
`;

export const ErrorButton = styled(TextButton)`
  color: ${colors('error')};
  text-decoration: underline;
`;
